import { createSlice } from '@reduxjs/toolkit';
import {
  DeletePortMasterRequest,
  DetailPortMasterRequest,
  DetailPortMasterResponse,
  SearchPortMasterRecord,
  SearchPortMasterRequest,
  SearchPortMasterResponse,
  UpdatePortMasterRequest,
} from 'api-types/src/types/port-master';
import i18n from 'i18n/i18n';

type PortMasterState = {
  loading: boolean;
  loadingExportExcel: boolean;
  filterSearchTotal: number;
  filterInitialSearchData: SearchPortMasterRecord[];
  filterSearchData: SearchPortMasterRecord[];
  sortSelected: string;
  sortDirection: string;
  message: string;
  portDetail: DetailPortMasterResponse | {};
  success: boolean;
};

const initialState: PortMasterState = {
  loading: false,
  loadingExportExcel: false,
  filterSearchTotal: 0,
  filterInitialSearchData: [],
  filterSearchData: [],
  sortSelected: '',
  sortDirection: '',
  message: '',
  portDetail: {},
  success: false,
};

export const portMasterSlice = createSlice({
  name: 'portMaster',
  initialState,
  reducers: {
    filterPort: (state, action: { payload: SearchPortMasterRequest }) => {
      state.loading = true;
      state.message = '';
    },
    filterPortSuccess: (state, action: { payload: SearchPortMasterResponse }) => {
      state.loading = false;
      state.filterInitialSearchData = action.payload?.records;
      state.filterSearchData = action.payload?.records;
      if (!action.payload?.total) {
        state.message = i18n.t('message.common.0001');
      }
      state.filterSearchTotal = action.payload?.total;
      state.success = false;
    },
    filterPortFailure: (state) => {
      state.loading = false;
    },
    getDetailPort: (state, action: { payload: DetailPortMasterRequest }) => {
      state.loading = true;
    },
    getDetailPortSuccess: (state, action: { payload: DetailPortMasterResponse }) => {
      state.loading = false;
      state.portDetail = action.payload;
    },
    getDetailPortFailure: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },
    setLoadingExportExcel: (state, action) => {
      state.loadingExportExcel = action.payload;
    },
    registerPort: (state, action: { payload: UpdatePortMasterRequest }) => {
      state.loading = true;
      state.success = false;
    },
    registerPortSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    registerPortFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload?.message;
    },
    updatePort: (state, action: { payload: UpdatePortMasterRequest }) => {
      state.loading = true;
      state.success = false;
    },
    updatePortSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    updatePortFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload?.message;
    },
    deletePort: (state, action: { payload: DeletePortMasterRequest }) => {
      state.loading = true;
      state.success = false;
    },
    deletePortSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    deletePortFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload.message;
    },
    cleanDataPort: (state) => {
      state.portDetail = {};
    },
    cleanData: (state) => {
      return {
        ...initialState,
      };
    },
  },
});

export const {
  filterPort,
  filterPortSuccess,
  filterPortFailure,
  setLoadingExportExcel,
  getDetailPort,
  getDetailPortSuccess,
  getDetailPortFailure,
  registerPort,
  registerPortSuccess,
  registerPortFailure,
  updatePort,
  updatePortSuccess,
  updatePortFailure,
  deletePort,
  deletePortSuccess,
  deletePortFailure,
  cleanDataPort,
  cleanData,
} = portMasterSlice.actions;

export default portMasterSlice.reducer;
